import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import Title from '../../Primitive/Title'
import { RowContext } from '@/component/Context/RowContext'

const HeaderWidget = ({ title, large, viewAllCtaLink }) => {
  const isInverse = useContext(RowContext)
  return (
    <Title
      bordered={!isInverse ? 'default' : null}
      inverse={isInverse}
      ctaLabel={viewAllCtaLink ? 'View all' : null}
      ctaUrl={viewAllCtaLink || null}
      title={title}
      isLarge={large}
    />
  )
}

HeaderWidget.propTypes = {
  title: PropTypes.string,
  large: PropTypes.bool,
  viewAllCtaLink: PropTypes.string
}

export default HeaderWidget
